import React from "react";
import PropTypes from "prop-types";

import {Wrapper} from "./styles";

const Options = ({ children, viewMode = "normal" }) => {
  return <Wrapper $viewMode={viewMode}>{children}</Wrapper>;
};

Options.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  viewMode: PropTypes.oneOf(["normal", "compact"]),
};

export default Options;
